import { Injectable } from '@angular/core';
import { OrderingOption } from 'generated/graphql-types';

@Injectable({ providedIn: 'root' })
export class LocationRegisterSessionStorageService {
   private readonly locationOrderingOptionsStorageKey = '__ndt-location-ordering-options';

   clearAll(): void {
      localStorage.clear();
   }

   removeLocationOrderingOptions(): void {
      localStorage.removeItem(this.locationOrderingOptionsStorageKey);
   }

   getLocationOrderingOptions() {
      const localData = localStorage.getItem(this.locationOrderingOptionsStorageKey);
      if (localData) {
         return JSON.parse(localData);
      }
      return null;
   }

   setLocationOrderingOptions(orderingOptions: OrderingOption[] | null): void {
      localStorage.setItem(this.locationOrderingOptionsStorageKey, JSON.stringify(orderingOptions));
   }
}
